<template>
  <div class="">
    <div
      class="card-title text-left d-flex align-items-center justify-content-between m-0 p-0"
    >
      <h3 v-if="mode === 'search'">
        <i class="bx bx-analyse"></i> Sandbox Analysis (
        {{ $t("malware.malware-search") }} )
      </h3>
      <h3 v-if="mode === 'input'">
        <i class="bx bx-analyse"></i> Sandbox Analysis (
        {{ $t("malware.malware-input") }} )
      </h3>
      <div class="">
        <b-button-group>
          <b-button
            size="sm"
            :variant="mode === 'search' ? 'primary' : 'outline-primary'"
            @click="changeMode('search')"
          >
            <i class="bx bx-search-alt font-size-16 align-middle py-1 px-1"></i>
          </b-button>
          <b-button
            size="sm"
            :variant="mode === 'input' ? 'primary' : 'outline-primary'"
            @click="changeMode('input')"
          >
            <i class="bx bx-pencil font-size-16 align-middle py-1 px-1"></i>
          </b-button>
        </b-button-group>
      </div>
    </div>
    <p class="card-title-desc text-left m-0 p-0">
      {{ $t("malware.analyse") }}
    </p>
    <hr />
    <b-alert show dismissible variant="danger" v-if="submitted && !isValid">
      <span class="d-flex align-items-center">
        <i class="bx bx-x-circle bx-sm mr-2"></i>
        {{ $t("malware.malware-data") }}
      </span>
    </b-alert>
    <div class="search-form mt-5" v-if="mode == 'search'">
      <div class="row">
        <div class="col-xl-8 col-lg-6 col-md-4 mb-3">
          <input
            v-model="form.searchKey"
            type="text"
            class="form-control"
            placeholder="Search name, hash, or IP Address .."
            v-on:keyup.enter="dummySearch"
          />
        </div>
        <div class="col-xl-4 col-lg-6 col-md-8">
          <div class="row">
            <div class="col-xl-4 col-lg-6 col-md-6 col-sm-4 mb-3">
              <select class="custom-select" v-model="sandbox_value">
                <option value="all">All Sandbox</option>
                <option value="1">Checkpoint</option>
                <option value="2">AhnLab</option>
              </select>
            </div>
            <div class="col-xl-4 col-lg-3 col-md-3 col-sm-6 mb-3">
              <b-button
                variant="primary"
                class="btn-block"
                @click="dummySearch"
              >
                <i class="bx bx-search font-size-16 align-middle"></i>
                <span class="d-xl-inline d-lg-none d-md-none">{{
                  $t("malware.search")
                }}</span>
              </b-button>
            </div>
            <div class="col-xl-4 col-lg-3 col-md-3 col-sm-2 mb-3">
              <b-button
                variant="primary"
                class="btn-block"
                v-b-toggle="'advanced-search'"
              >
                <i class="bx bx-filter font-size-16 align-middle"></i>
                <span class="d-xl-inline d-lg-none d-md-none d-sm-none">{{
                  $t("malware.advanced")
                }}</span>
              </b-button>
            </div>
          </div>
        </div>
        <div class="col-12">
          <b-collapse id="advanced-search" class="mt-1">
            <hr class="mt-4 mb-0" />
            <div class="py-4">
              <div class="row">
                <div class="col-12 col-sm-6 col-md-6 col-lg-3">
                  <div class="form-group">
                    <label for="validationCustom01">{{
                      $t("malware.file-name")
                    }}</label>
                    <input
                      id="validationCustom01"
                      type="text"
                      class="form-control"
                      placeholder="example.exe"
                      v-model="form.advanced.file_name"
                    />
                  </div>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-3">
                  <div class="form-group">
                    <label for="validationCustom01">{{
                      $t("malware.threat-name")
                    }}</label>
                    <input
                      id="validationCustom01"
                      type="text"
                      class="form-control"
                      placeholder="Trojan.mW"
                      v-model="form.advanced.threat_name"
                    />
                  </div>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-3">
                  <div class="form-group">
                    <label for="validationCustom01">{{
                      $t("malware.file-type")
                    }}</label>
                    <input
                      id="validationCustom01"
                      type="text"
                      class="form-control"
                      placeholder="exe"
                      v-model="form.advanced.file_type"
                    />
                  </div>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-3">
                  <div class="form-group">
                    <label for="validationCustom01">{{
                      $t("malware.ip-address")
                    }}</label>
                    <input
                      id="validationCustom01"
                      type="text"
                      class="form-control"
                      placeholder="10.10.xx.xxx"
                      v-model="form.advanced.ip_address"
                    />
                  </div>
                </div>
                <div class="col-12 col-sm-6 col-md-6">
                  <div class="form-group">
                    <label for="validationCustom01">MD5</label>
                    <input
                      id="validationCustom01"
                      type="text"
                      class="form-control"
                      placeholder="c0d5b1cc0c77fcf32ff02aac98fac536"
                      v-model="form.advanced.md5"
                    />
                  </div>
                </div>
                <div class="col-12 col-sm-6 col-md-6">
                  <div class="form-group">
                    <label for="validationCustom01">SHA-1</label>
                    <input
                      id="validationCustom01"
                      type="text"
                      class="form-control"
                      placeholder="2154845e38fc348ae1be419684f9572a680fabfd"
                      v-model="form.advanced.sha1"
                    />
                  </div>
                </div>
                <div class="col-12 text-right">
                  <b-button variant="primary" class="px-5" @click="dummySearch">
                    <i class="bx bx-search font-size-16 align-middle mr-2"></i>
                    {{ $t("malware.search") }}
                  </b-button>
                </div>
              </div>
            </div>
          </b-collapse>
        </div>
      </div>
    </div>
    <div class="search-form pt-4" v-if="mode == 'input'">
      <div class="row">
        <div class="col-12">
          <div class="row">
            <div class="col-4">
              <h5>{{ $t("malware.basic-properties") }}</h5>
              <p>{{ $t("malware.fill-basic") }}</p>
            </div>
            <div class="col-8">
              <div class="row">
                <div class="col-6">
                  <div class="form-group">
                    <label for="threat_name">{{
                      $t("malware.threat-name")
                    }}</label>
                    <input
                      id="threat_name"
                      v-model="form.input.threat_name"
                      type="text"
                      class="form-control"
                      placeholder="Trojan/mW32"
                    />
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-group">
                    <label for="classification">
                      {{ $t("malware.classification") }}
                      <small class="text-danger">*</small></label
                    >
                    <input
                      id="classification"
                      v-model="form.input.classification"
                      type="text"
                      class="form-control"
                      placeholder="Trojan"
                      :class="{
                        'is-invalid':
                          submitted && $v.form.input.classification.$error,
                      }"
                    />
                    <div
                      v-if="submitted && $v.form.input.classification.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.input.classification.required">{{
                        $t("form.error.text")
                      }}</span>
                    </div>
                  </div>
                </div>
                <div class="col-3">
                  <div class="form-group">
                    <label for="file_name"
                      >{{ $t("malware.file-name") }}
                      <small class="text-danger">*</small></label
                    >
                    <input
                      id="file_name"
                      v-model="form.input.file_name"
                      type="text"
                      class="form-control"
                      placeholder="example.exe"
                      :class="{
                        'is-invalid':
                          submitted && $v.form.input.file_name.$error,
                      }"
                    />
                    <div
                      v-if="submitted && $v.form.input.file_name.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.input.file_name.required">{{
                        $t("form.error.text")
                      }}</span>
                    </div>
                  </div>
                </div>
                <div class="col-3">
                  <div class="form-group">
                    <label for="file_type"
                      >{{ $t("malware.file-type") }}
                      <small class="text-danger">*</small></label
                    >
                    <input
                      id="file_type"
                      v-model="form.input.file_type"
                      type="text"
                      class="form-control"
                      placeholder="exe"
                      :class="{
                        'is-invalid':
                          submitted && $v.form.input.file_type.$error,
                      }"
                    />
                    <div
                      v-if="submitted && $v.form.input.file_type.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.input.file_type.required">{{
                        $t("form.error.text")
                      }}</span>
                    </div>
                  </div>
                </div>
                <div class="col-3">
                  <div class="form-group">
                    <label for="file_size"
                      >{{ $t("malware.file-size") }}
                      <small class="text-danger">* </small>
                      <small>( in Bytes )</small></label
                    >
                    <input
                      id="file_size"
                      v-model="form.input.file_size"
                      type="text"
                      class="form-control"
                      placeholder="201290"
                      :class="{
                        'is-invalid':
                          submitted && $v.form.input.file_size.$error,
                      }"
                    />
                    <div
                      v-if="submitted && $v.form.input.file_size.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.input.file_size.required">{{
                        $t("form.error.text")
                      }}</span>
                    </div>
                  </div>
                </div>
                <div class="col-3">
                  <div class="form-group">
                    <label for="severity"
                      >{{ $t("malware.severity") }}
                      <small class="text-danger">* </small></label
                    >
                    <input
                      id="severity"
                      v-model="form.input.severity"
                      type="text"
                      class="form-control"
                      placeholder="20"
                      :class="{
                        'is-invalid':
                          submitted && $v.form.input.severity.$error,
                      }"
                    />
                    <div
                      v-if="submitted && $v.form.input.severity.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.input.severity.required">{{
                        $t("form.error.text")
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 my-2">
          <hr />
        </div>
        <div class="col-12 mt-5">
          <div class="row">
            <div class="col-4">
              <h5>Hash</h5>
              <p>{{ $t("malware.fill-hash") }} (MD5, SHA-1, SHA-256)</p>
            </div>
            <div class="col-8">
              <div class="row">
                <div class="col-4">
                  <div class="form-group">
                    <label for="md5"
                      >MD5 <small class="text-danger">*</small></label
                    >
                    <input
                      id="md5"
                      v-model="form.input.md5"
                      type="text"
                      class="form-control"
                      placeholder="c0d5b1cc0c77fcf32ff02aac98fac536"
                      :class="{
                        'is-invalid': submitted && $v.form.input.md5.$error,
                      }"
                    />
                    <div
                      v-if="submitted && $v.form.input.md5.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.input.md5.required">{{
                        $t("form.error.text")
                      }}</span>
                    </div>
                  </div>
                </div>
                <div class="col-4">
                  <div class="form-group">
                    <label for="sha1">SHA-1</label>
                    <input
                      id="sha1"
                      v-model="form.input.sha1"
                      type="text"
                      class="form-control"
                      placeholder="2154845e38fc348ae1be419684f9572a680fabfd"
                    />
                  </div>
                </div>
                <div class="col-4">
                  <div class="form-group">
                    <label for="sha256">SHA-256</label>
                    <input
                      id="sha256"
                      v-model="form.input.sha256"
                      type="text"
                      class="form-control"
                      placeholder="e68f38195b3c816309882388c23118327ec97f9ad775bf59b9a8a3089dd68fd8"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 my-2">
          <hr />
        </div>
        <div class="col-12 mt-5">
          <div class="row">
            <div class="col-4">
              <h5>{{ $t("malware.information-on-execution") }}</h5>
              <p>Fill in the information about the execution of the malware</p>
            </div>
            <div class="col-8">
              <div class="row">
                <div class="col-6">
                  <div class="form-group">
                    <label for="starttime">{{
                      $t("malware.start-time")
                    }}</label>
                    <input
                      id="starttime"
                      v-model="form.input.index_time"
                      type="datetime-local"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-group">
                    <label for="finishtime"
                      >{{ $t("malware.finish-time") }}
                    </label>
                    <input
                      id="finishtime"
                      v-model="form.input.finish_time"
                      type="datetime-local"
                      class="form-control"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr />
    <div class="col-12 p-0" v-if="mode == 'search'">
      <div class="loading text-center py-5 my-5" v-if="loading.search">
        <div class="text-center">
          <i class="bx bx-loader-circle bx-spin bx-md"></i> <br />
          <span class="font-size-16"> {{ $t("malware.searching") }} </span>
        </div>
      </div>
      <div v-if="isSearch">
        <div class="card" v-if="sandbox_value == '1' || sandbox_value == 'all'">
          <div class="card-body">
            <div class="card-title">
              <div class="d-flex">
                <div class="">
                  <h4>Checkpoint Result</h4>
                  <p class="font-size-12 font-weight-normal">
                    {{ searchResult1.length }} result found
                  </p>
                </div>
              </div>
            </div>

            <div class="" v-if="searchResult1.length != 0">
              <div v-for="(sr1, id1) in searchResult1" :key="id1">
                <div
                  class="d-block rounded border border-light mb-5"
                  :class="theme == 'dark' ? 'border-primary' : 'border-light'"
                >
                  <div class="row px-2">
                    <div class="col-lg-12">
                      <div
                        class="d-block rounded px-2 py-2"
                        :class="theme == 'dark' ? '' : 'bg-light'"
                      >
                        <div
                          class="d-flex justify-content-between align-items-center"
                        >
                          <h5
                            class="mb-0"
                            :class="theme == 'dark' ? 'text-white' : ''"
                          >
                            Hash :
                            {{ sr1._source.md5 }}
                          </h5>
                          <span>
                            <b-button
                              size="sm"
                              :variant="
                                selected_malware.sandbox1.id === id1
                                  ? 'success'
                                  : 'outline-success'
                              "
                              class="rounded"
                              @click="dummySelectMalware(id1, 1)"
                            >
                              <span v-if="selected_malware.sandbox1.id === id1"
                                >Selected</span
                              >
                              <span v-else>Select</span>
                            </b-button>
                            <b-button
                              size="sm"
                              :variant="
                                theme == 'dark' ? 'transparent' : 'light'
                              "
                              class="rounded"
                              v-b-toggle="'detail-checkpoint' + id1"
                            >
                              <i
                                class="bx bx-chevron-down bx-sm font-size-16 align-middle"
                              ></i>
                            </b-button>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6 py-2">
                      <div class="row px-2">
                        <div class="col-lg-12">
                          <label for="" class="text-white">Threat Name</label>
                          <p>
                            {{
                              sr1._source.av.malware_info
                                ? sr1._source.av.malware_info.signature_name
                                : "-"
                            }}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6 py-2">
                      <div class="row px-2">
                        <div class="col-3"></div>
                        <div class="col-3">
                          <label for="" class="text-white">File Size</label>
                          <p>
                            {{
                              detailInfo.length != 0 &&
                              detailInfo[id1].tech_detail
                                ? formatByte(
                                    detailInfo[id1].tech_detail.file_size
                                  )
                                : "-"
                            }}
                          </p>
                        </div>
                        <!-- <div class="col-3">
                          <label for="">Index Time</label>
                          <p class="mb-0">{{ sr1._source.index_time }}</p>
                          <p class="font-italic mb-0">2 Year Ago</p>
                        </div> -->
                        <div class="col-3">
                          <label for="" class="text-white">File Type</label>
                          <p>{{ sr1._source.file_type }}</p>
                        </div>
                        <div class="col-3 mb-2">
                          <div class="avatar-md">
                            <span
                              class="avatar-title rounded-circle bg-light text-danger font-size-16"
                            >
                              <img
                                :src="
                                  require('@/assets/images/file-type/' +
                                    getFileTypeIcon(sr1._source.file_type))
                                "
                                alt
                                height="40"
                              />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <b-collapse :id="'detail-checkpoint' + id1" class="mt-1">
                    <div class="row mb-3">
                      <div class="col-lg-12 mb-3">
                        <div
                          class="d-block rounded mt-3 h-100"
                          :class="theme == 'dark' ? '' : 'border-light'"
                        >
                          <b-tabs
                            nav-class="nav-tabs-custom"
                            content-class="p-3 text-muted"
                          >
                            <b-tab active>
                              <template v-slot:title>
                                <span class="d-inline-block d-sm-none">
                                  <i class="bx bx-detail"></i>
                                </span>
                                <span class="d-none d-sm-inline-block mx-5 my-2"
                                  >Details</span
                                >
                              </template>
                              <div class="card-body p-0 py-3">
                                <h5 class="py-1 px-2">DETAIL INFORMATION</h5>
                                <hr />
                                <div class="row">
                                  <div class="col-4"></div>
                                </div>
                                <div class="table-responsive">
                                  <table
                                    class="table mb-0"
                                    style="border-top: none"
                                  >
                                    <tbody>
                                      <tr class="text-white">
                                        <th
                                          colspan="2"
                                          style="border-top: none"
                                        >
                                          <h5>Basic Properties</h5>
                                        </th>
                                      </tr>
                                      <tr>
                                        <td
                                          width="20%"
                                          class="font-weight-bold"
                                        >
                                          MD5
                                        </td>
                                        <td>
                                          {{ sr1._source.md5 }}
                                          <button
                                            class="btn btn-transparent"
                                            title="Copy"
                                            @click="copyText(sr1._source.md5)"
                                          >
                                            <i
                                              class="ml-1 text-primary bx bx-copy"
                                            ></i>
                                          </button>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td class="font-weight-bold">SHA-1</td>
                                        <td>
                                          {{ sr1._source.sha1 }}
                                          <button
                                            class="btn btn-transparent"
                                            title="Copy"
                                            @click="copyText(sr1._source.sha1)"
                                          >
                                            <i
                                              class="ml-1 text-primary bx bx-copy"
                                            ></i>
                                          </button>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td class="font-weight-bold">
                                          SHA-256
                                        </td>
                                        <td>
                                          {{ sr1._source.sha256 }}
                                          <button
                                            class="btn btn-transparent"
                                            title="Copy"
                                            @click="
                                              copyText(sr1._source.sha256)
                                            "
                                          >
                                            <i
                                              class="ml-1 text-primary bx bx-copy"
                                            ></i>
                                          </button>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td class="font-weight-bold">
                                          File Type
                                        </td>
                                        <td>{{ sr1._source.file_type }}</td>
                                      </tr>
                                      <tr>
                                        <td class="font-weight-bold">
                                          File Size
                                        </td>
                                        <td>
                                          {{
                                            detailInfo.length != 0 &&
                                            detailInfo[id1].tech_detail
                                              ? formatByte(
                                                  detailInfo[id1].tech_detail
                                                    .file_size
                                                ) +
                                                " ( " +
                                                (detailInfo[id].tech_detail
                                                  .file_size
                                                  ? detailInfo[id].tech_detail
                                                      .file_size
                                                  : "0") +
                                                " Byte )"
                                              : "-"
                                          }}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                                <div class="mt-5 pb-3">
                                  <h5>Information On Execution</h5>
                                  <hr />
                                  <div class="row">
                                    <div class="col-4"></div>
                                  </div>
                                  <table
                                    class="table mb-0"
                                    style="border-top: none"
                                  >
                                    <tbody>
                                      <tr>
                                        <td
                                          width="20%"
                                          class="font-weight-bold"
                                          style="border-top: none"
                                        >
                                          Start Execution
                                        </td>
                                        <td style="border-top: none">
                                          {{
                                            formatDetectTime(
                                              sr1._source.detect_time
                                            )
                                          }}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td class="font-weight-bold">
                                          Finish Execution
                                        </td>
                                        <td>
                                          {{ sr1._source.analysis_time }}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td class="font-weight-bold">
                                          File Name
                                        </td>
                                        <td>
                                          {{ sr1._source.file_name }}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td class="font-weight-bold">
                                          Threat Name
                                        </td>
                                        <td>
                                          {{
                                            sr1._source.av.malware_info
                                              ? sr1._source.av.malware_info
                                                  .signature_name
                                              : "-"
                                          }}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td class="font-weight-bold">
                                          Classification
                                        </td>
                                        <td>
                                          <div
                                            class=""
                                            v-if="
                                              detailInfo.length != 0 &&
                                              detailInfo[id1].classification
                                            "
                                          >
                                            <span
                                              class="badge badge-primary mr-2 px-2 py-1"
                                              v-for="(cl, idcl) in detailInfo[
                                                id1
                                              ].classification"
                                              :key="idcl"
                                              >{{ cl }}</span
                                            >
                                          </div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td class="font-weight-bold">
                                          Severity
                                        </td>
                                        <td>
                                          {{ sr1._source.te.severity }} ({{
                                            detailInfo.length != 0 &&
                                            detailInfo[id1].general_res
                                              ? detailInfo[id1].general_res
                                                  .Severity
                                              : ""
                                          }})
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </b-tab>
                            <b-tab>
                              <template v-slot:title>
                                <span class="d-inline-block d-sm-none">
                                  <i class="bx bx-sitemap"></i>
                                </span>
                                <span class="d-none d-sm-inline-block mx-5 my-2"
                                  >Relations</span
                                >
                              </template>
                              <div class="card-body p-0 py-3">
                                <h5 class="py-1 px-2">RELATED INFORMATION</h5>
                                <hr />
                                <div class="row px-3">
                                  <div
                                    class="col-12 border border-left-0 border-right-0 border-top-0 py-3"
                                  >
                                    <h5>Connected IP Address</h5>
                                  </div>
                                  <div class="col-12">
                                    <p class="mt-5 text-center">
                                      Data not found
                                    </p>
                                  </div>
                                </div>
                                <!-- <div class="row mt-5 px-3">
                                  <div
                                    class="col-12 border border-left-0 border-right-0 border-top-0 py-3"
                                  >
                                    Related Files
                                  </div>
                                  <div class="col-12"></div>
                                </div> -->
                              </div>
                            </b-tab>

                            <b-tab>
                              <template v-slot:title>
                                <span class="d-inline-block d-sm-none">
                                  <i class="bx bx-sitemap"></i>
                                </span>
                                <span class="d-none d-sm-inline-block mx-5 my-2"
                                  >Screen Capture</span
                                >
                              </template>
                              <div class="card-body p-0 py-3">
                                <h5 class="py-1 px-2">SCREEN CAPTURE</h5>
                                <hr />
                                <div
                                  class="row"
                                  v-if="
                                    detailInfo.length != 0 &&
                                    detailInfo[id1].emu_videos &&
                                    detailInfo[id].emu_videos.length != 0
                                  "
                                >
                                  <div
                                    class="col-3 p-4"
                                    v-for="(ev, idev) in detailInfo[id1]
                                      .emu_videos"
                                    :key="idev"
                                  >
                                    <span class="my-2">{{
                                      ev.image_name
                                    }}</span>
                                    <span @click="modalImage()">
                                      <video width="100%" class="my-3" controls>
                                        <source
                                          :src="
                                            sc_url_cp +
                                            'md5=' +
                                            sr1._source.md5 +
                                            '&path=' +
                                            ev.url
                                          "
                                          type="video/mp4"
                                        />
                                        Your browser does not support the video
                                        tag.
                                      </video>
                                    </span>
                                  </div>
                                </div>
                                <div class="row" v-else>
                                  <div class="col-12">
                                    <p class="mt-5 text-center">
                                      Data not found
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </b-tab>

                            <b-tab>
                              <template v-slot:title>
                                <span class="d-inline-block d-sm-none">
                                  <i class="bx bx-sitemap"></i>
                                </span>
                                <span class="d-none d-sm-inline-block mx-5 my-2"
                                  >Suspicious Activities</span
                                >
                              </template>
                              <div class="card-body p-0">
                                <div
                                  class="d-flex justify-content-between align-items-center py-1 px-2"
                                >
                                  <h5 class="py-1">SUSPICIOUS ACTIVITIES</h5>
                                  <div
                                    class="d-flex justify-content-end align-items-center"
                                    style="width: 20%"
                                  >
                                    <span for="" class="mr-2"
                                      >Running On :
                                    </span>
                                    <select
                                      style="width: 50%; float: right"
                                      class="form-control"
                                      v-model="cp_susact_vm[sr1._source.md5]"
                                      @change="
                                        changeCpSusactVm(sr1._source.md5)
                                      "
                                    >
                                      <option
                                        v-for="(
                                          optVm, idOpt
                                        ) in detailInfo.length != 0
                                          ? detailInfo[id1].suspicious_act
                                              .images
                                          : []"
                                        :key="idOpt"
                                        :value="sr1._source.md5 + '_' + idOpt"
                                      >
                                        {{ optVm.image }}
                                      </option>
                                    </select>
                                  </div>
                                </div>
                                <hr />
                                <div class="row mt-4">
                                  <div class="col-sm-12 col-md-6">
                                    <div
                                      id="tickets-table_length"
                                      class="dataTables_length"
                                    >
                                      <label
                                        class="d-inline-flex align-items-center"
                                      >
                                        {{ $t("table.show_label") }}&nbsp;&nbsp;
                                        <b-form-select
                                          v-model="perPage"
                                          size="sm"
                                          :options="pageOptions"
                                          class="mx-1"
                                        ></b-form-select
                                        >&nbsp;&nbsp;{{
                                          $t("table.entri_label")
                                        }}
                                      </label>
                                    </div>
                                  </div>
                                  <!-- Search -->
                                  <div class="col-sm-12 col-md-6">
                                    <div
                                      id="tickets-table_filter"
                                      class="dataTables_filter text-md-right"
                                    >
                                      <label
                                        class="d-inline-flex align-items-center"
                                      >
                                        {{ $t("table.search_label") }}:
                                        <b-form-input
                                          v-model="filter"
                                          type="search"
                                          :placeholder="
                                            $t('navbar.search.text')
                                          "
                                          class="form-control form-control-sm ml-2"
                                        ></b-form-input>
                                      </label>
                                    </div>
                                  </div>
                                  <!-- End search -->
                                </div>
                                <div class="table-responsive mb-0">
                                  <div
                                    class="text-center mt-5"
                                    v-if="loading.change_cp_susact_vm"
                                  >
                                    <i
                                      class="bx bx-loader-circle bx-spin bx-md"
                                    ></i>
                                    <h5>Loading....</h5>
                                  </div>
                                  <b-table
                                    v-if="!loading.change_cp_susact_vm"
                                    :items="
                                      cp_table_susact[sr1._source.md5]
                                        ? cp_table_susact[sr1._source.md5].data
                                        : []
                                    "
                                    :fields="fields_cp"
                                    responsive="sm"
                                    :per-page="perPage"
                                    :current-page="currentPage"
                                    :sort-desc.sync="sortDesc"
                                    :filter="filter"
                                    :filter-included-fields="filterOn"
                                    @filtered="onFiltered"
                                    show-empty
                                  >
                                    <template #cell(no)="row">
                                      {{ row.item.no + 1 }}
                                    </template>
                                    <template #empty="scope">
                                      <p class="mt-5 text-center">
                                        Data not found
                                      </p>
                                    </template>
                                  </b-table>
                                </div>
                                <div
                                  class="row"
                                  v-if="
                                    !loading.change_cp_susact_vm &&
                                    rowscp(cp_susact_vm[sr1._source.md5]) > 10
                                  "
                                >
                                  <div class="col-2">
                                    <label
                                      class="d-inline-flex align-items-center"
                                    >
                                      Page
                                      <b-form-input
                                        v-model="currentPage"
                                        placeholder="Page"
                                        class="form-control w-10 form-control ml-2"
                                      ></b-form-input>
                                    </label>
                                  </div>
                                  <div
                                    class="col-10 text-right"
                                    v-if="
                                      rowscp(cp_susact_vm[sr1._source.md5]) > 10
                                    "
                                  >
                                    <div
                                      class="dataTables_paginate paging_simple_numbers float-right"
                                    >
                                      <ul
                                        class="pagination pagination-rounded mb-0"
                                        :class="
                                          theme == 'dark'
                                            ? 'custom-paginate-dark'
                                            : 'custom-paginate'
                                        "
                                      >
                                        <b-pagination
                                          v-model="currentPage"
                                          :total-rows="
                                            rowscp(
                                              cp_susact_vm[sr1._source.md5]
                                            )
                                          "
                                          :per-page="perPage"
                                        ></b-pagination>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </b-tab>
                          </b-tabs>
                        </div>
                      </div>
                    </div>
                  </b-collapse>
                </div>
              </div>
            </div>
            <div class="py-4" v-else>
              <div class="text-center">
                <img
                  src="@/assets/images/no-results.png"
                  alt
                  height="150"
                /><br />
                <span class="font-size-16"> Not Found </span>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div
          class="card mt-4"
          v-if="sandbox_value == '2' || sandbox_value == 'all'"
        >
          <div class="card-body">
            <div class="card-title">
              <div class="d-flex">
                <div class="">
                  <h4>AhnLab Result</h4>
                  <p class="font-size-12 font-weight-normal">
                    {{ searchResult2.length }} result found
                  </p>
                </div>
              </div>
            </div>
            <div class="" v-if="Object.keys(searchResult2).length != 0">
              <div v-for="(sr2, id2) in searchResult2" :key="id2">
                <div
                  class="d-block rounded border mb-5"
                  :class="theme == 'dark' ? '' : 'border-light'"
                >
                  <div class="row px-2">
                    <div class="col-lg-12">
                      <div
                        class="d-block rounded px-2 py-2"
                        :class="theme == 'dark' ? '' : 'bg-light'"
                      >
                        <div
                          class="d-flex justify-content-between align-items-center"
                        >
                          <h5
                            class="mb-0"
                            :class="theme == 'dark' ? 'text-white' : ''"
                          >
                            Hash :
                            {{ sr2[0]._source.md5sum }}
                          </h5>
                          <span>
                            <b-button
                              size="sm"
                              :variant="
                                selected_malware.sandbox2.id === id2
                                  ? 'success'
                                  : 'outline-success'
                              "
                              class="rounded"
                              @click="dummySelectMalware(id2, 2)"
                            >
                              <span v-if="selected_malware.sandbox2.id === id2"
                                >Selected</span
                              >
                              <span v-else>Select</span>
                            </b-button>
                            <b-button
                              size="sm"
                              :variant="
                                theme == 'dark' ? 'transparent' : 'light'
                              "
                              class="rounded"
                              v-b-toggle="'detail-ahnlab' + id2"
                            >
                              <i
                                class="bx bx-chevron-down bx-sm font-size-16 align-middle"
                              ></i>
                            </b-button>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6 py-2">
                      <div class="row px-2">
                        <div class="col-lg-12">
                          <label for="" class="text-white">Threat Name</label>
                          <p>{{ sr2[0]._source.detect_name }}</p>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6 py-2">
                      <div class="row px-2">
                        <div class="col-3"></div>
                        <div class="col-3">
                          <label for="" class="text-white">File Size</label>
                          <p>{{ formatByte(sr2[0]._source.file_size) }}</p>
                        </div>
                        <div class="col-3">
                          <label for="" class="text-white">File Type</label>
                          <p>
                            {{
                              sr2[0]._source.file_type
                                ? sr2[0]._source.file_type
                                : "Unknown"
                            }}
                          </p>
                        </div>
                        <div class="col-3 mb-2">
                          <div class="avatar-md">
                            <span
                              class="avatar-title rounded-circle bg-light text-danger font-size-16"
                            >
                              <img
                                :src="
                                  require('@/assets/images/file-type/' +
                                    getFileTypeIcon(sr2[0]._source.file_type))
                                "
                                alt
                                height="40"
                              />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <b-collapse :id="'detail-ahnlab' + id2" class="mt-1">
                    <div class="row mb-3">
                      <div class="col-lg-12 mb-3">
                        <div
                          class="d-block rounded mt-3 h-100"
                          :class="theme == 'dark' ? '' : 'border-light'"
                        >
                          <b-tabs
                            nav-class="nav-tabs-custom"
                            content-class="p-3 text-muted"
                          >
                            <b-tab active>
                              <template v-slot:title>
                                <span class="d-inline-block d-sm-none">
                                  <i class="bx bx-detail"></i>
                                </span>
                                <span class="d-none d-sm-inline-block mx-5 my-2"
                                  >Details</span
                                >
                              </template>
                              <div class="card-body p-0 py-3">
                                <h5 class="py-1 px-2">DETAIL INFORMATION</h5>
                                <hr />
                                <div class="row">
                                  <div class="col-4"></div>
                                </div>
                                <div class="table-responsive">
                                  <table
                                    class="table mb-0"
                                    style="border-top: none"
                                  >
                                    <tbody>
                                      <tr class="text-white">
                                        <th
                                          colspan="2"
                                          style="border-top: none"
                                        >
                                          <h5>Basic Properties</h5>
                                        </th>
                                      </tr>
                                      <tr>
                                        <td
                                          width="20%"
                                          class="font-weight-bold"
                                        >
                                          MD5
                                        </td>
                                        <td>
                                          {{ sr2[0]._source.md5sum }}
                                          <button
                                            class="btn btn-transparent"
                                            title="Copy"
                                            @click="
                                              copyText(sr2[0]._source.md5sum)
                                            "
                                          >
                                            <i
                                              class="ml-1 text-primary bx bx-copy"
                                            ></i>
                                          </button>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td class="font-weight-bold">SHA-1</td>
                                        <td>-</td>
                                      </tr>
                                      <tr>
                                        <td class="font-weight-bold">
                                          SHA-256
                                        </td>
                                        <td>-</td>
                                      </tr>
                                      <tr>
                                        <td class="font-weight-bold">
                                          File Type
                                        </td>
                                        <td>{{ sr2[0]._source.file_type }}</td>
                                      </tr>
                                      <tr>
                                        <td class="font-weight-bold">
                                          File Size
                                        </td>
                                        <td>
                                          {{
                                            formatByte(sr2[0]._source.file_size)
                                          }}
                                          ( {{ sr2[0]._source.file_size }} Byte
                                          )
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                                <div class="mt-5 px-3 pb-3">
                                  <h5>Information On Execution</h5>
                                </div>
                                <b-tabs
                                  justified
                                  content-class="py-3 text-muted"
                                >
                                  <b-tab
                                    class="border-0"
                                    v-for="(ioe, ioeidx) in sr2"
                                    :key="ioeidx"
                                    :active="ioeidx == 0"
                                  >
                                    <template v-slot:title>
                                      <span class="d-inline-block d-sm-none">
                                        <i class="fas fa-home"></i>
                                      </span>
                                      <span
                                        class="d-none d-sm-inline-block"
                                        v-if="ioe._source.running_vm == 'vm1'"
                                        >Windows XP</span
                                      >
                                      <span
                                        class="d-none d-sm-inline-block"
                                        v-if="ioe._source.running_vm == 'vm2'"
                                        >Windows 7</span
                                      >
                                      <span
                                        class="d-none d-sm-inline-block"
                                        v-if="ioe._source.running_vm == 'vm3'"
                                        >Windows 10</span
                                      >
                                      <span
                                        class="d-none d-sm-inline-block"
                                        v-if="ioe._source.running_vm == 'vm4'"
                                        >Windows 11</span
                                      >
                                    </template>
                                    <div class="table-responsive">
                                      <table
                                        class="table mb-0"
                                        style="border-top: none"
                                      >
                                        <tbody>
                                          <tr>
                                            <td
                                              width="20%"
                                              class="font-weight-bold"
                                              style="border-top: none"
                                            >
                                              Start Execution
                                            </td>
                                            <td style="border-top: none">
                                              {{
                                                formatDetectTime(
                                                  ioe._source.detect_time
                                                )
                                              }}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td class="font-weight-bold">
                                              Finish Execution
                                            </td>
                                            <td>
                                              {{ ioe._source.analysis_time }}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td class="font-weight-bold">
                                              File Name
                                            </td>
                                            <td>
                                              {{ ioe._source.file_name }}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td class="font-weight-bold">
                                              Threat Name
                                            </td>
                                            <td>
                                              {{ ioe._source.detect_name }}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td class="font-weight-bold">
                                              Classification
                                            </td>
                                            <td>
                                              {{ ioe._source.detect_name }}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td class="font-weight-bold">
                                              Severity
                                            </td>
                                            <td>
                                              {{ ioe._source.severity }}
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </b-tab>
                                </b-tabs>
                              </div>
                            </b-tab>
                            <b-tab>
                              <template v-slot:title>
                                <span class="d-inline-block d-sm-none">
                                  <i class="bx bx-sitemap"></i>
                                </span>
                                <span class="d-none d-sm-inline-block mx-5 my-2"
                                  >Relations</span
                                >
                              </template>
                              <div class="card-body p-0 py-3">
                                <h5 class="py-1 px-2">RELATED INFORMATION</h5>
                                <hr />
                                <div class="row px-3">
                                  <div
                                    class="col-12 border border-left-0 border-right-0 border-top-0 py-3"
                                  >
                                    <h5>Connected IP Address</h5>
                                  </div>
                                  <div class="col-12">
                                    <p class="mt-5 text-center">
                                      Data not found
                                    </p>
                                  </div>
                                </div>
                                <!-- <div class="row mt-5 px-3">
                                  <div
                                    class="col-12 border border-left-0 border-right-0 border-top-0 py-3"
                                  >
                                    Related Files
                                  </div>
                                  <div class="col-12"></div>
                                </div> -->
                              </div>
                            </b-tab>

                            <b-tab>
                              <template v-slot:title>
                                <span class="d-inline-block d-sm-none">
                                  <i class="bx bx-sitemap"></i>
                                </span>
                                <span class="d-none d-sm-inline-block mx-5 my-2"
                                  >Screen Capture</span
                                >
                              </template>
                              <div class="card-body p-0 py-3">
                                <h5 class="py-1 px-2">SCREEN CAPTURE</h5>
                                <hr />
                                <div class="row" v-if="sr2.length == 0">
                                  <div
                                    class="col-3 p-4"
                                    v-for="(sc, scidx) in sr2"
                                    :key="scidx"
                                  >
                                    <span
                                      class="my-2"
                                      v-if="sc._source.running_vm == 'vm1'"
                                      >Windows XP</span
                                    >
                                    <span
                                      class="my-2"
                                      v-if="sc._source.running_vm == 'vm2'"
                                      >Windows 7</span
                                    >
                                    <span
                                      class="my-2"
                                      v-if="sc._source.running_vm == 'vm3'"
                                      >Windows 10</span
                                    >
                                    <span
                                      class="my-2"
                                      v-if="sc._source.running_vm == 'vm4'"
                                      >Windows 11</span
                                    >
                                    <img
                                      :src="
                                        sc_url_ahn +
                                        'md5=' +
                                        sc._source.md5sum +
                                        '&vm=' +
                                        sc._source.running_vm
                                      "
                                      alt=""
                                      width="100%"
                                      class="my-3"
                                    />
                                  </div>
                                </div>
                                <div class="row" v-else>
                                  <div class="col-12">
                                    <p class="mt-5 text-center">
                                      Data not found
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </b-tab>

                            <b-tab>
                              <template v-slot:title>
                                <span class="d-inline-block d-sm-none">
                                  <i class="bx bx-sitemap"></i>
                                </span>
                                <span class="d-none d-sm-inline-block mx-5 my-2"
                                  >Suspicious Activities</span
                                >
                              </template>
                              <div class="card-body p-0">
                                <div
                                  class="d-flex justify-content-between align-items-center py-1 px-2"
                                >
                                  <h5 class="py-1">SUSPICIOUS ACTIVITIES</h5>
                                  <div
                                    class="d-flex justify-content-end align-items-center"
                                    style="width: 20%"
                                  >
                                    <span for="" class="mr-2"
                                      >Running On :
                                    </span>
                                    <select
                                      style="width: 50%; float: right"
                                      class="form-control"
                                      v-model="susact_vm[id2]"
                                      @change="changeSusactVm(id2)"
                                    >
                                      <option
                                        v-for="(sa, saidx) in sr2"
                                        :key="saidx"
                                        :value="
                                          sa._source.md5sum +
                                          '_' +
                                          sa._source.running_vm
                                        "
                                      >
                                        <span
                                          v-if="sa._source.running_vm == 'vm1'"
                                          >Windows XP</span
                                        >
                                        <span
                                          v-if="sa._source.running_vm == 'vm2'"
                                          >Windows 7</span
                                        >
                                        <span
                                          v-if="sa._source.running_vm == 'vm3'"
                                          >Windows 10</span
                                        >
                                        <span
                                          v-if="sa._source.running_vm == 'vm4'"
                                          >Windows 11</span
                                        >
                                      </option>
                                    </select>
                                  </div>
                                </div>
                                <hr />
                                <div class="row mt-4">
                                  <div class="col-sm-12 col-md-6">
                                    <div
                                      id="tickets-table_length"
                                      class="dataTables_length"
                                    >
                                      <label
                                        class="d-inline-flex align-items-center"
                                      >
                                        {{ $t("table.show_label") }}&nbsp;&nbsp;
                                        <b-form-select
                                          v-model="perPage"
                                          size="sm"
                                          :options="pageOptions"
                                          class="mx-1"
                                        ></b-form-select
                                        >&nbsp;&nbsp;{{
                                          $t("table.entri_label")
                                        }}
                                      </label>
                                    </div>
                                  </div>
                                  <!-- Search -->
                                  <div class="col-sm-12 col-md-6">
                                    <div
                                      id="tickets-table_filter"
                                      class="dataTables_filter text-md-right"
                                    >
                                      <label
                                        class="d-inline-flex align-items-center"
                                      >
                                        {{ $t("table.search_label") }}:
                                        <b-form-input
                                          v-model="filter"
                                          type="search"
                                          :placeholder="
                                            $t('navbar.search.text')
                                          "
                                          class="form-control form-control-sm ml-2"
                                        ></b-form-input>
                                      </label>
                                      <span
                                        class="ml-4 mr-2 custom-icon"
                                        title="Download File XML"
                                        @click="downloadAnalysisFile(id2)"
                                      >
                                        <i
                                          class="bx bx-cloud-download bx-sm font-size-16 align-middle"
                                        ></i>
                                      </span>
                                    </div>
                                  </div>
                                  <!-- End search -->
                                </div>
                                <div class="table-responsive mb-0">
                                  <div
                                    class="text-center mt-5"
                                    v-if="loading.change_susact_vm"
                                  >
                                    <i
                                      class="bx bx-loader-circle bx-spin bx-md"
                                    ></i>
                                    <h5>Loading....</h5>
                                  </div>
                                  <b-table
                                    v-if="!loading.change_susact_vm"
                                    :items="table_susact[id2]"
                                    :fields="fields"
                                    responsive="sm"
                                    :per-page="perPage"
                                    :current-page="currentPage"
                                    :sort-desc.sync="sortDesc"
                                    :filter="filter"
                                    :filter-included-fields="filterOn"
                                    @filtered="onFiltered"
                                    show-empty
                                  >
                                    <template #cell(no)="row">
                                      <span>{{ row.item.no + 1 }}</span>
                                    </template>
                                    <template
                                      #cell(actionData.actionTime)="row"
                                    >
                                      <span>
                                        {{
                                          formatTime(
                                            row.item.actionData.actionTime
                                          )
                                        }}</span
                                      >
                                    </template>
                                    <template #empty="scope">
                                      <p class="mt-5 text-center">
                                        Data not found
                                      </p>
                                    </template>
                                  </b-table>
                                </div>
                                <div
                                  class="row"
                                  v-if="
                                    !loading.change_susact_vm &&
                                    rows(susact_vm[id2]) > 10
                                  "
                                >
                                  <div class="col-2">
                                    <label
                                      class="d-inline-flex align-items-center"
                                    >
                                      Page
                                      <b-form-input
                                        v-model="currentPage"
                                        placeholder="Page"
                                        class="form-control w-10 form-control ml-2"
                                      ></b-form-input>
                                    </label>
                                  </div>
                                  <div
                                    class="col-10 text-right"
                                    v-if="rows(susact_vm[id2]) > 10"
                                  >
                                    <div
                                      class="dataTables_paginate paging_simple_numbers float-right"
                                    >
                                      <ul
                                        class="pagination pagination-rounded mb-0"
                                        :class="
                                          theme == 'dark'
                                            ? 'custom-paginate-dark'
                                            : 'custom-paginate'
                                        "
                                      >
                                        <b-pagination
                                          v-model="currentPage"
                                          :total-rows="rows(susact_vm[id2])"
                                          :per-page="perPage"
                                        ></b-pagination>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </b-tab>
                          </b-tabs>
                        </div>
                      </div>
                    </div>
                  </b-collapse>
                </div>
              </div>
            </div>
            <div class="py-4" v-else>
              <div class="text-center">
                <img
                  src="@/assets/images/no-results.png"
                  alt
                  height="150"
                /><br />
                <span class="font-size-16"> Not Found </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import ReportService from "@/helpers/report.service";
import { userService } from "@/helpers/authservice/user.service";
import { malwareData1, malwareData2 } from "./../data-malware";
import StatisticsService from "@/helpers/statistics.service";
import IpAddressService from "@/helpers/ipaddress.service";
import MalwareServices from "@/helpers/malware.service";
import Helpers from "@/helpers/auxiliary.function";
import PreferencesServices from "@/helpers/preferences.service";
import ElasticService from "@/helpers/elastic.service";
import moment from "moment";
import _ from "lodash";

/**
 * Projects-grid component
 */
export default {
  props: {
    validations: Boolean,
    reportType: { type: String, default: "" },
    idReport: { type: String, default: "" },
  },
  data() {
    return {
      sc_url_cp: process.env.VUE_APP_BASE_API_URL_SCREENCAPTURE_CP,
      sc_url_ahn: process.env.VUE_APP_BASE_API_URL_SCREENCAPTURE_AHN,
      malwareData1: malwareData1,
      malwareData2: malwareData2,
      submitted: false,

      form: {
        input: {
          threat_name: "",
          classification: "",
          file_name: "",
          file_type: "",
          file_size: "",
          severity: "",
          md5: "",
          sha1: "",
          sha256: "",
          index_time: "",
          finish_time: "",
          dst: "",
        },
        searchKey: "",
        advanced: {
          file_name: "",
          threat_name: "",
          file_type: "",
          ip_address: "",
          md5: "",
          sha1: "",
        },
      },
      searchResult1: [],
      searchResult2: [],
      ip_elastic: "http://10.10.30.249:9200/",
      ip_elastic_cp: "",
      ip_elastic_ahn: "",
      ip_reputation: "",
      sandbox_value: "all",
      report_type: "",
      selected_malware: {
        sandbox1: {
          id: "",
          data: "",
        },
        sandbox2: {
          id: "",
          data: "",
        },
      },
      theme: localStorage.getItem("theme") ?? "light",
      isShow: false,
      isSearch: false,
      loading: {
        search: false,
        checkip: false,
        susact: {},
        change_susact_vm: false,
        change_cp_susact_vm: false,
        ioe: false,
      },
      isValid: true,
      mode: "search",
      suspicious_activity: {},
      susact_vm: {},
      table_susact: {},
      cp_suspicious_activity: {},
      cp_susact_vm: {},
      cp_table_susact: {},

      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "no",
          class: "text-center",
          thStyle: { width: "2%" },
          label: "No",
        },
        {
          key: "actionData.@attributes.actionCategory",
          class: "text-left",
          thStyle: { width: "10%" },
          label: "Category",
        },
        {
          key: "actionData.actionTime",
          sortable: true,
          label: "Time",
        },
        {
          key: "actionData.message.description",
          sortable: true,
          label: "Description",
        },
      ],
      fields_cp: [
        {
          key: "no",
          class: "text-center",
          thStyle: { width: "2%" },
          label: "No",
        },
        {
          key: "category",
          class: "text-left",
          thStyle: { width: "10%" },
          label: "Category",
        },
        {
          key: "count",
          sortable: true,
          label: "Count",
        },
        {
          key: "description",
          sortable: true,
          label: "Description",
        },
      ],
    };
  },
  validations: {
    form: {
      input: {
        classification: { required },
        file_name: { required },
        file_type: { required },
        file_size: { required },
        severity: { required },
        md5: { required },
      },
    },
  },
  watch: {
    validations: {
      immediate: true,
      handler(n) {
        if (n) {
          this.validation();
        }
      },
    },
    reportType: {
      immediate: true,
      handler(n) {
        if (n) {
          this.report_type = n;
        }
      },
    },
  },
  methods: {
    rows(id) {
      return this.suspicious_activity[id] &&
        this.suspicious_activity[id].data.length != 0
        ? this.suspicious_activity[id].data.length
        : 0;
    },
    rowscp(id) {
      return this.cp_suspicious_activity[id] &&
        this.cp_suspicious_activity[id].data.length != 0
        ? this.cp_suspicious_activity[id].data.length
        : 0;
    },
    changeSusactVm(id) {
      let idSusact = this.susact_vm[id];
      const tableSusact = Object.fromEntries([
        [
          id,
          this.suspicious_activity[idSusact] &&
          this.suspicious_activity[idSusact].data.length != 0
            ? this.suspicious_activity[idSusact].data
            : [],
        ],
      ]);
      Object.assign(this.table_susact, tableSusact);

      this.loading.change_susact_vm = true;

      setTimeout(() => {
        this.loading.change_susact_vm = false;
      }, 1000);
    },
    changeCpSusactVm(id) {
      let idSusact = this.cp_susact_vm[id];
      const tableCpSusact = Object.fromEntries([
        [
          id,
          this.cp_suspicious_activity[idSusact] &&
          this.cp_suspicious_activity[idSusact].data.length != 0
            ? this.cp_suspicious_activity[idSusact]
            : [],
        ],
      ]);
      Object.assign(this.cp_table_susact, tableCpSusact);
      this.loading.change_cp_susact_vm = true;

      setTimeout(() => {
        this.loading.change_cp_susact_vm = false;
      }, 1000);
    },

    getPreferencesCp() {
      PreferencesServices.getByKey("elastic", "checkpoint")
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.getPreferencesCp();
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            this.ip_elastic_cp = response.data.data;
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.getPreferencesCP();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
            }
          }
        });
    },
    getPreferencesAhn() {
      PreferencesServices.getByKey("elastic", "ahn_lab")
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.getPreferencesAhn();
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            this.ip_elastic_ahn = response.data.data;
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.getPreferencesAhn();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
            }
          }
        });
    },
    detailReport() {
      let ferr = 0;
      if (this.idReport) {
        this.loading.search = true;
        ReportService.detail(this.idReport)
          .then((res) => {
            if (res.status == 201) {
              let new_token = res.data.refresh_access_token;
              userService.splitToken(new_token);
              this.detailReport();
              ferr = 1;
              this.$store.dispatch("notification/refreshtoken", "refresh");
            } else {
              ferr = 2;
              const malware = res.data.data.malware_data;
              const mw = JSON.parse(malware);
              console.log("detail report ", res);
              mw.forEach((ele, idx) => {
                console.log("malware data report ", ele);
                if (ele != null && ele.sandbox_source == "0") {
                  this.form = {
                    input: {
                      threat_name: mw[idx].threat_name,
                      classification: mw[idx].classification,
                      file_name: mw[idx].file_name,
                      file_type: mw[idx].file_type,
                      file_size: mw[idx].file_size,
                      severity: mw[idx].severity,
                      md5: mw[idx].md5,
                      sha1: mw[idx].sha1,
                      sha256: mw[idx].sha256,
                      index_time:
                        moment(mw[idx].index_time).format("YYYY-MM-DDTHH:ss") ??
                        "",
                      finish_time:
                        moment(mw[idx].finish_time).format(
                          "YYYY-MM-DDTHH:ss"
                        ) ?? "",
                      dst: mw[idx].dst ?? "",
                    },
                    searchKey: "",
                    advanced: {
                      file_name: "",
                      threat_name: "",
                      file_type: "",
                      ip_address: "",
                      md5: "",
                      sha1: "",
                    },
                  };
                  this.mode = "input";
                }
                if (ele != null && ele.sandbox_source == "1") {
                  this.searchDetailCheckpoint(ele.id);
                }
                if (ele != null && ele.sandbox_source == "2") {
                  this.searchDetailAhnLab(ele.id);
                }
              });
              this.loading.search = false;
            }
          })
          .catch((err) => {
            if (err.response == undefined) {
              console.log("err ->> ", err);
              this.loading.search = false;
            } else if (
              this.$store.state.notification.type === "refresh-token" &&
              err.response.status == 401
            ) {
              this.detailReport();
            } else {
              if (err.response.status == 401) {
                userService.logout();
              } else {
                console.log("err ->> ", err);
                this.loading.search = false;
              }
            }
          });
      }
    },

    dummySearch() {
      if (this.form.searchKey != "") {
        this.isSearch = false;
        this.loading.search = true;
        if (this.sandbox_value == "1" || this.sandbox_value == "all") {
          this.searchCheckpoint();
        }
        if (this.sandbox_value == "2" || this.sandbox_value == "all") {
          this.searchAhnLab();
        }
        setTimeout(() => {
          this.loading.search = false;
          this.isSearch = true;
        }, 1500);
      }
    },
    dummyAdvancedSearch() {
      if (
        this.form.advanced.file_name != "" ||
        this.form.advanced.threat_name != "" ||
        this.form.advanced.file_type != "" ||
        this.form.advanced.ip_address != "" ||
        this.form.advanced.md5 != "" ||
        this.form.advanced.sha1 != ""
      ) {
        this.isSearch = false;
        this.loading.search = true;
        if (this.sandbox_value == "1" || this.sandbox_value == "all") {
          this.searchCheckpoint(true);
        }
        if (this.sandbox_value == "2" || this.sandbox_value == "all") {
          this.searchAhnLab(true);
        }
        setTimeout(() => {
          this.loading.search = false;
          this.isSearch = true;
        }, 1500);
      }
    },
    dummySelectMalware(idx, sandbox) {
      if (sandbox == 1) {
        const selected_data = {
          sandbox_source: sandbox,
          id: this.searchResult1[idx]._id,
          malware: this.searchResult1[idx]._source,
        };

        this.selected_malware.sandbox1.id = idx;
        this.selected_malware.sandbox1.data = selected_data;

        console.log("log select ", this.searchResult1[idx]._id);
      }
      if (sandbox == 2) {
        let malwareData = [];
        let susactData = [];
        this.searchResult2[idx].forEach((ele) => {
          malwareData.push({
            threat_name: ele._source.classification,
            file_name: ele._source.file_name,
            file_size: ele._source.file_size,
            file_type: ele._source.file_type,
            classification: ele._source.classification,
            severity: ele._source.severity,
            md5: ele._source.md5sum,
            sha1: ele._source.file_sha1,
            sha256: ele._source.file_sha256,
            dst: ele._source.dst,
            running_vm: ele._source.running_vm,
            analysis_time: ele._source.analysis_time,
          });
        });
        const selected_data = {
          sandbox_source: sandbox,
          id: idx,
          malware: this.searchResult2[idx],
        };

        // this.selected_malware.sandbox = sandbox;
        this.selected_malware.sandbox2.id = idx;
        this.selected_malware.sandbox2.data = selected_data;
      }

      console.log("tess", this.selected_malware);

      // if (this.selected_malware.data.length != 0) {
      //   this.selected_malware.sandbox = 0;
      //   this.selected_malware.data = [];
      // } else {
      //   this.selected_malware.sandbox = sandbox;
      //   this.selected_malware.data.push(search);
      // }
    },
    searchCheckpoint(advanced = false) {
      let bodyQuery = {
        size: 100,
        query: {
          bool: {
            filter: [],
            should: [],
            must_not: [],
          },
        },
      };

      if (!advanced) {
        const optionQuery = {
          bool: {
            should: [
              {
                bool: {
                  should: [
                    {
                      query_string: {
                        fields: ["file_name"],
                        query: "*" + this.form.searchKey + "*",
                      },
                    },
                  ],
                  minimum_should_match: 1,
                },
              },
              {
                bool: {
                  should: [
                    {
                      bool: {
                        should: [
                          {
                            match: {
                              md5: this.form.searchKey,
                            },
                          },
                        ],
                        minimum_should_match: 1,
                      },
                    },
                    {
                      bool: {
                        should: [
                          {
                            bool: {
                              should: [
                                {
                                  query_string: {
                                    fields: ["av.malware_info.signature_name"],
                                    query: "*" + this.form.searchKey + "*",
                                  },
                                },
                              ],
                              minimum_should_match: 1,
                            },
                          },
                          {
                            bool: {
                              should: [
                                {
                                  bool: {
                                    should: [
                                      {
                                        match: {
                                          sha1: this.form.searchKey,
                                        },
                                      },
                                    ],
                                    minimum_should_match: 1,
                                  },
                                },
                                {
                                  bool: {
                                    should: [
                                      {
                                        match: {
                                          sha256: this.form.searchKey,
                                        },
                                      },
                                    ],
                                    minimum_should_match: 1,
                                  },
                                },
                              ],
                              minimum_should_match: 1,
                            },
                          },
                        ],
                        minimum_should_match: 1,
                      },
                    },
                  ],
                  minimum_should_match: 1,
                },
              },
            ],
            minimum_should_match: 1,
          },
        };
        bodyQuery.query.bool.filter.push(optionQuery);
      }

      if (advanced) {
        const optionQuery = {
          bool: {
            should: [
              {
                bool: {
                  should: [
                    {
                      query_string: {
                        fields: ["file_name"],
                        query: "*" + this.form.advanced.file_name + "*",
                      },
                    },
                  ],
                  minimum_should_match: 1,
                },
              },
              {
                bool: {
                  should: [
                    {
                      bool: {
                        should: [
                          {
                            match: {
                              md5: this.form.advanced.md5,
                            },
                          },
                        ],
                        minimum_should_match: 1,
                      },
                    },
                    {
                      bool: {
                        should: [
                          {
                            bool: {
                              should: [
                                {
                                  match: {
                                    file_type: this.form.advanced.file_type,
                                  },
                                },
                              ],
                              minimum_should_match: 1,
                            },
                          },
                          {
                            bool: {
                              should: [
                                {
                                  bool: {
                                    should: [
                                      {
                                        query_string: {
                                          fields: [
                                            "av.malware_info.signature_name",
                                          ],
                                          query:
                                            this.form.advanced.threat_name == ""
                                              ? ""
                                              : "*" +
                                                this.form.advanced.threat_name +
                                                "*",
                                        },
                                      },
                                    ],
                                    minimum_should_match: 1,
                                  },
                                },
                                {
                                  bool: {
                                    should: [
                                      {
                                        match: {
                                          sha1: this.form.advanced.sha1,
                                        },
                                      },
                                    ],
                                    minimum_should_match: 1,
                                  },
                                },
                              ],
                              minimum_should_match: 1,
                            },
                          },
                        ],
                        minimum_should_match: 1,
                      },
                    },
                  ],
                  minimum_should_match: 1,
                },
              },
            ],
            minimum_should_match: 1,
          },
        };
        bodyQuery.query.bool.filter.push(optionQuery);
      }

      if (this.ip_elastic_cp.username && this.ip_elastic_cp.password) {
        let usps =
          this.ip_elastic_cp.username + ":" + this.ip_elastic_cp.password;
        let base = Helpers.encode(usps);
        var basedata_cp = "Basic " + base + "";
      } else {
        var basedata_cp = null;
      }

      ElasticService.getCheckpointLab(
        this.ip_elastic_cp.api_host,
        bodyQuery,
        basedata_cp
      )
        .then((response) => {
          this.searchResult1 = response.data.hits.hits;
          this.detailInfo = [];
          this.searchResult1.forEach((el) => {
            this.getDetailInfo(el._source.md5);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    searchAhnLab(advanced = false) {
      let bodyQuery = {
        size: 100,
        query: {
          bool: {
            filter: [],
            should: [],
            must_not: [],
          },
        },
      };

      if (!advanced) {
        const optionQuery = {
          bool: {
            should: [
              {
                bool: {
                  should: [
                    {
                      query_string: {
                        fields: ["detect_name"],
                        query: "*" + this.form.searchKey + "*",
                      },
                    },
                  ],
                  minimum_should_match: 1,
                },
              },
              {
                bool: {
                  should: [
                    {
                      match_phrase: {
                        md5sum: this.form.searchKey,
                      },
                    },
                  ],
                  minimum_should_match: 1,
                },
              },
              {
                bool: {
                  should: [
                    {
                      query_string: {
                        fields: ["file_name"],
                        query: "*" + this.form.searchKey + "*",
                      },
                    },
                  ],
                  minimum_should_match: 1,
                },
              },
            ],
            minimum_should_match: 1,
          },
        };
        bodyQuery.query.bool.filter.push(optionQuery);
      }

      if (advanced) {
        const optionQuery = {
          bool: {
            should: [
              {
                bool: {
                  should: [
                    {
                      query_string: {
                        fields: ["detect_name"],
                        query: "*" + this.form.advanced.threat_name + "*",
                      },
                    },
                  ],
                  minimum_should_match: 1,
                },
              },
              {
                bool: {
                  should: [
                    {
                      bool: {
                        should: [
                          {
                            query_string: {
                              fields: ["file_name"],
                              query: "*" + this.form.advanced.file_name + "*",
                            },
                          },
                        ],
                        minimum_should_match: 1,
                      },
                    },
                    {
                      bool: {
                        should: [
                          {
                            bool: {
                              should: [
                                {
                                  match_phrase: {
                                    file_type: this.form.advanced.file_type,
                                  },
                                },
                              ],
                              minimum_should_match: 1,
                            },
                          },
                          {
                            bool: {
                              should: [
                                {
                                  match_phrase: {
                                    md5sum: this.form.advanced.md5,
                                  },
                                },
                              ],
                              minimum_should_match: 1,
                            },
                          },
                        ],
                        minimum_should_match: 1,
                      },
                    },
                  ],
                  minimum_should_match: 1,
                },
              },
            ],
            minimum_should_match: 1,
          },
        };
        bodyQuery.query.bool.filter.push(optionQuery);
      }

      if (this.ip_elastic_ahn.username && this.ip_elastic_ahn.password) {
        let usps =
          this.ip_elastic_ahn.username + ":" + this.ip_elastic_ahn.password;
        let base = Helpers.encode(usps);
        var basedata_ahn = "Basic " + base + "";
      } else {
        var basedata_ahn = null;
      }

      ElasticService.getAhnLab(
        this.ip_elastic_ahn.api_host,
        bodyQuery,
        basedata_ahn
      )
        .then((response) => {
          this.searchResult2 = _.groupBy(
            response.data.hits.hits,
            "_source.md5sum"
          );
          let grouped = _.groupBy(response.data.hits.hits, "_source.md5sum");

          this.setDefaultSusact(grouped);
          // get suspicious activity if exist in download list
          response.data.hits.hits.forEach((el) => {
            if (el._source.download.includes("dica")) {
              this.getSuspiciousActivity(
                "1",
                el._source.md5sum,
                el._source.running_vm
              );
            }
            if (el._source.download.includes("mdp")) {
              this.getSuspiciousActivity(
                "2",
                el._source.md5sum,
                el._source.running_vm
              );
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    setDefaultSusact(grouped) {
      Object.keys(grouped).forEach((ele) => {
        // make default selected vm suspicious activity
        const defaultSusact = Object.fromEntries([
          [
            ele,
            grouped[ele][0]._source.md5sum +
              "_" +
              grouped[ele][0]._source.running_vm,
          ],
        ]);
        Object.assign(this.susact_vm, defaultSusact);
      });
    },
    setDefaultSusactCp(md5, grouped) {
      // make default selected vm suspicious activity
      const defaultSusactCp = Object.fromEntries([[md5, md5 + "_0"]]);
      Object.assign(this.cp_susact_vm, defaultSusactCp);

      const defaultTableSusactCp = Object.fromEntries([
        [
          md5,
          {
            image: grouped[0].image,
            data: grouped[0].behaviors.map((el, idx) => {
              return { ...el, ...{ no: idx } };
            }),
          },
        ],
      ]);
      Object.assign(this.cp_table_susact, defaultTableSusactCp);
    },
    getSuspiciousActivity(type, md5, vm) {
      this.loading.change_susact_vm = true;
      MalwareServices.ahnSupiciousActivity(type, md5, vm)
        .then((res) => {
          if (res.status == 201) {
            let new_token = res.data.refresh_access_token;
            userService.splitToken(new_token);
            this.getSuspiciousActivity(type, md5, vm);
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            let withIndex = [];
            if (
              typeof res.data.analysisDataGroup != undefined &&
              res.data.analysisDataGroup?.analysisData
            ) {
              withIndex = res.data.analysisDataGroup.analysisData.map(
                (el, idx) => {
                  return { ...el, ...{ no: idx } };
                }
              );
            }

            // set detail activity to variable suspicious_activity
            const susObject = Object.fromEntries([
              [md5 + "_" + vm, { data: withIndex }],
            ]);
            Object.assign(this.suspicious_activity, susObject);
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.getSuspiciousActivity(type, md5, vm);
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log("err activity", err);
            }
          }
        })
        .finally(() => {
          // make default content table suspicious activity
          Object.keys(this.searchResult2).forEach((ele) => {
            let idSusact =
              this.searchResult2[ele][0]._source.md5sum +
              "_" +
              this.searchResult2[ele][0]._source.running_vm;

            const defaultTableSusact = Object.fromEntries([
              [
                ele,
                this.suspicious_activity[idSusact] &&
                this.suspicious_activity[idSusact].data.length != 0
                  ? this.suspicious_activity[idSusact].data
                  : [],
              ],
            ]);
            Object.assign(this.table_susact, defaultTableSusact);
          });

          setTimeout(() => {
            this.loading.change_susact_vm = false;
          }, 1000);
        });
    },
    getDetailInfo(md5) {
      const bodyData = {
        md5: md5,
      };
      this.loading.change_cp_susact_vm = true;
      MalwareServices.cpDetail(bodyData)
        .then((res) => {
          this.detailInfo.push(res.data.data);
          this.setDefaultSusactCp(md5, res.data.data.suspicious_act.images);
          res.data.data.suspicious_act.images.forEach((ele, idx) => {
            // set detail activity to variable cp_suspicious_activity
            const susCpObject = Object.fromEntries([
              [
                md5 + "_" + idx,
                {
                  image: ele.image,
                  data: ele.behaviors.map((el, idx) => {
                    return { ...el, ...{ no: idx } };
                  }),
                },
              ],
            ]);
            Object.assign(this.cp_suspicious_activity, susCpObject);
          });
          setTimeout(() => {
            this.loading.change_cp_susact_vm = false;
          }, 1000);
        })
        .catch((err) => {
          console.log("lokal err ", err);
          setTimeout(() => {
            this.loading.change_cp_susact_vm = false;
          }, 1000);
        });
    },
    searchDetailCheckpoint(hashKey) {
      let bodyQuery = {
        size: 100,
        query: {
          bool: {
            filter: [],
            should: [],
            must_not: [],
          },
        },
      };

      const optionQuery = {
        bool: {
          should: [
            {
              bool: {
                should: [
                  {
                    match: {
                      md5: hashKey,
                    },
                  },
                ],
                minimum_should_match: 1,
              },
            },
          ],
          minimum_should_match: 1,
        },
      };
      bodyQuery.query.bool.filter.push(optionQuery);

      if (this.ip_elastic_cp.username && this.ip_elastic_cp.password) {
        let usps =
          this.ip_elastic_cp.username + ":" + this.ip_elastic_cp.password;
        let base = Helpers.encode(usps);
        var basedata_cp = "Basic " + base + "";
      } else {
        var basedata_cp = null;
      }

      ElasticService.getCheckpointLab(
        this.ip_elastic_cp.api_host,
        bodyQuery,
        basedata_cp
      )
        .then((response) => {
          this.searchResult1 = response.data.hits.hits;
          this.detailInfo = [];
          this.searchResult1.forEach((el) => {
            this.getDetailInfo(el._source.md5);
          });
          this.isSearch = true;
          this.selected_malware.sandbox1.id = hashKey;
          console.log("SearchRes 1 ", this.searchResult1);
          this.dummySelectMalware(0, 1);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    searchDetailAhnLab(hashKey) {
      let bodyQuery = {
        size: 100,
        query: {
          bool: {
            filter: [],
            should: [],
            must_not: [],
          },
        },
      };

      const optionQuery = {
        bool: {
          should: [
            {
              bool: {
                should: [
                  {
                    match_phrase: {
                      md5sum: hashKey,
                    },
                  },
                ],
                minimum_should_match: 1,
              },
            },
          ],
          minimum_should_match: 1,
        },
      };
      bodyQuery.query.bool.filter.push(optionQuery);

      if (this.ip_elastic_ahn.username && this.ip_elastic_ahn.password) {
        let usps =
          this.ip_elastic_ahn.username + ":" + this.ip_elastic_ahn.password;
        let base = Helpers.encode(usps);
        var basedata_ahn = "Basic " + base + "";
      } else {
        var basedata_ahn = null;
      }

      ElasticService.getAhnLab(
        this.ip_elastic_ahn.api_host,
        bodyQuery,
        basedata_ahn
      )
        .then((response) => {
          this.searchResult2 = _.groupBy(
            response.data.hits.hits,
            "_source.md5sum"
          );
          let grouped = _.groupBy(response.data.hits.hits, "_source.md5sum");

          this.setDefaultSusact(grouped);
          // get suspicious activity if exist in download list
          response.data.hits.hits.forEach((el) => {
            if (el._source.download.includes("dica")) {
              this.getSuspiciousActivity(
                "1",
                el._source.md5sum,
                el._source.running_vm
              );
            }
            if (el._source.download.includes("mdp")) {
              this.getSuspiciousActivity(
                "2",
                el._source.md5sum,
                el._source.running_vm
              );
            }
          });
          this.isSearch = true;
          this.selected_malware.sandbox2.id = 0;
          this.dummySelectMalware(hashKey, 2);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getFileTypeIcon(key) {
      let fileicon = "unknown.png";
      switch (key) {
        case "doc":
          fileicon = "docs.png";
          break;
        case "docx":
          fileicon = "docs.png";
          break;
        case "pdf":
          fileicon = "pdf.png";
          break;
        case "exe":
          fileicon = "exe.png";
          break;
        case "text/html":
          fileicon = "html.png";
          break;
        case "html":
          fileicon = "html.png";
          break;
        case "zip":
          fileicon = "compress.png";
          break;
        case "rar":
          fileicon = "compress.png";
          break;
        case "tar":
          fileicon = "compress.png";
          break;
        case "text":
          fileicon = "txt.png";
          break;
        default:
          break;
      }
      return fileicon;
    },
    changeMode(val) {
      console.log("log change ", this.form);
      this.mode = val;
    },
    showMap() {
      this.isShow = this.isShow ? false : true;
    },
    updateReport() {
      const fromx = [this.form];
      let ferr = 0;
      let dataReport = {};
      if (this.mode == "input") {
        const d = { ...{ sandbox_source: 0 }, ...this.form.input };
        dataReport = {
          malware_data: [d],
        };
      } else {
        dataReport = {
          malware_data: [
            this.selected_malware.sandbox1.data,
            this.selected_malware.sandbox2.data,
          ],
        };
      }
      // console.log(this.form, this.selected_malware);
      ReportService.update(this.idReport, dataReport)
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.updateReport();
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            ferr = 2;
            this.$emit("id-report", response.data.data.id_report);
            this.$emit("next-tab");
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.updateReport();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
              this.loading = false;
            }
          }
        });
    },
    validation() {
      this.submitted = true;
      this.isValid = true;
      this.$v.form.$touch();
      if (this.mode == "input") {
        if (!this.$v.form.$invalid) {
          this.updateReport();
        } else {
          this.$emit("validation-failed");
          this.submitted = false;
          setTimeout(() => {
            this.submitted = true;
            this.isValid = false;
          }, 200);
        }
      }
      if (this.mode == "search") {
        console.log("sand 1", this.selected_malware.sandbox1);
        console.log("sand 2", this.selected_malware.sandbox2);
        if (
          this.selected_malware.sandbox1.data ||
          this.selected_malware.sandbox2.data
        ) {
          this.updateReport();
        } else {
          this.$emit("validation-failed");
          this.submitted = false;
          setTimeout(() => {
            this.submitted = true;
            this.isValid = false;
          }, 200);
        }
      }
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    formatDate(value) {
      return moment(value).format("YYYY-MM-DD, hh:mm");
    },
    formatTime(value) {
      return moment(value).format("YYYY-MM-DD, hh:mm:ss");
    },
    formatDetectTime(val) {
      return moment(val).utcOffset("+14:00").format("YYYY-MM-DD HH:mm:ss");
    },
    formatByte(val) {
      return Helpers.formatBytes(val);
    },
  },
  beforeMount() {
    this.getPreferencesCp();
    this.getPreferencesAhn();
  },
  mounted() {
    this.detailReport();
  },
};
</script>
<style>
.custom-icon:hover {
  cursor: pointer;
  color: #1a3fa3;
}
.page-item.active .page-link {
  background-color: #024284 !important;
  border-color: #024284 !important;
}
.custom-paginate-dark .page-item.disabled .page-link {
  color: #a6b0ae !important;
  background-color: #022b3a !important;
}
.custom-paginate .page-item.disabled .page-link {
  color: #a6b0ae !important;
  background-color: #eff2f7 !important;
}
</style>
